module.exports = __webpack_public_path__ + "img/[糗大了].69511f01.svg";